import React from "react";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { validate, validators } from "validate-redux-form";
import { renderField, renderNumber } from "../../Utils/renderField";

const CrearEditarForm = (props) => {
    const { handleSubmit } = props;
    return (
        <form
            name="CrearEditarForm"
            className="form-validate mb-lg"
            onSubmit={handleSubmit}
        >
            <div className="row w-70">
                <div className="form-group has-feedback col-12">
                    <label htmlFor="descripcion">Descripción</label>
                    <Field
                        name="descripcion"
                        label="Descripción"
                        component={renderField}
                        type="text"
                        className="input--style"
                        placeholder="Descripción..."
                    />
                </div>
            </div>
            <div className="row w-70">
                <div className="form-group has-feedback col-12">
                    <label htmlFor="rango_horas_minima">
                        Rango de horas mínima
                    </label>
                    <Field
                        name="rango_horas_minima"
                        label="Rango de horas mínima"
                        component={renderNumber}
                        suffix=" hrs"
                        className="input--style"
                        placeholder="hrs..."
                    />
                </div>
            </div>
            <div className="row w-70">
                <div className="form-group has-feedback col-12">
                    <label htmlFor="rango_horas_maxima">
                        Rango de horas máxima
                    </label>
                    <Field
                        name="rango_horas_maxima"
                        label="Rango de horas máxima"
                        component={renderNumber}
                        suffix=" hrs"
                        className="input--style"
                        placeholder="hrs..."
                    />
                </div>
            </div>
            <div className="buttons-box">
                <Link
                    to="/complejidad_proyectos"
                    className="btn"
                    style={{ fontSize: 15 }}
                >
                    Cancelar
                </Link>
                <button
                    type="submit"
                    style={{ fontSize: 15 }}
                    className="btn btn-primary m-1 align-self-center"
                >
                    Guardar
                </button>
            </div>
        </form>
    );
};

export default reduxForm({
    form: "CrearEditarForm", // a unique identifier for this form
    validate: (data) => {
        return validate(data, {
            descripcion: validators.exists()("Este campo es requerido"),
            rango_horas_maxima: validators.number({ min: 0 })(
                "Valor mayor o igual a 0 requerido"
            ),
            rango_horas_minima: validators.number({ min: 0 })(
                "Valor mayor o igual a 0 requerido"
            ),
        });
    },
})(CrearEditarForm);
